import { render, staticRenderFns } from "./eightinfo.vue?vue&type=template&id=ff9f0686&scoped=true&"
import script from "./eightinfo.vue?vue&type=script&lang=js&"
export * from "./eightinfo.vue?vue&type=script&lang=js&"
import style0 from "./eightinfo.vue?vue&type=style&index=0&id=ff9f0686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9f0686",
  null
  
)

export default component.exports